import styled from "styled-components";
import { useAddPolicySubjectContext } from "./AddPolicySubjectContext";
import { ButtonCancel, ButtonConfirm } from "../../../Layout/Buttons";
import { useTranslation } from "react-i18next";
import SubjectPersonalDataForm from "../Forms/SubjectPersonalDataForm";
import SubjectContactsForm from "../Forms/SubjectContactsForm";
import PolicySubjectAddressesForm from "../../../MainTabs/MainTabContent/ClaimDetails/components/ClaimTabDetails/PolicySubjects/PolicySubject/PolicySubjectTabDetails/PolicySubjectAddressesForm";
import SubjectPaymentMethodsList from "../SubjectPaymentMethodsList";

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: flex-end;
`;

interface IAddPolicySubjectSummaryStepProps {
  onPreviousStep: () => void;
  onCreateClaim: () => void;
}

const AddPolicySubjectSummaryStep = ({
  onPreviousStep,
  onCreateClaim,
}: IAddPolicySubjectSummaryStepProps) => {
  const { t } = useTranslation();

  const { addPolicySubjectData, policySubjectRole } =
    useAddPolicySubjectContext();

  return (
    <>
      <SubjectPersonalDataForm
        subjectId={addPolicySubjectData?.id}
        subjectPersonalData={addPolicySubjectData?.personalData!}
        readonly={true}
      />

      <SubjectContactsForm
        subjectContacts={addPolicySubjectData?.contacts}
        disableForm={true}
      />

      <PolicySubjectAddressesForm
        addresses={addPolicySubjectData?.addresses}
        disableForm={true}
      />

      <SubjectPaymentMethodsList
        paymentMethods={addPolicySubjectData?.paymentMethods!}
      />

      <ButtonsWrapper>
        <ButtonCancel onClick={onPreviousStep}>
          {t("BUTTONS.previous")!}
        </ButtonCancel>

        <ButtonConfirm onClick={() => onCreateClaim()}>
          {t("BUTTONS.add-policy-subject")!}
        </ButtonConfirm>
      </ButtonsWrapper>
    </>
  );
};

export default AddPolicySubjectSummaryStep;
